(function ($) {
    'use strict';

    var attributionStorageKey = 'dd_anfragen_attribution_v1';
    var attributionLifetime = 90 * 24 * 60 * 60 * 1000;
    var attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
 
    function getStoredAttribution() {
        try {
            var stored = window.localStorage.getItem(attributionStorageKey);
            var attribution = stored ? JSON.parse(stored) : null;

            if (!attribution || !attribution.expiresAt || attribution.expiresAt < Date.now()) {
                window.localStorage.removeItem(attributionStorageKey);
                return null;
            }

            return attribution;
        } catch (error) {
            return null;
        }
    }

    function getQueryParameter(parameterName) {
        var params = new URLSearchParams(window.location.search);
        return (params.get(parameterName) || '').substring(0, 255);
    }

    function getCurrentTouch() {
        var touch = {
            landing_page: window.location.href,
            referrer: document.referrer || '',
            captured_at: new Date().toISOString()
        };
        var hasCampaignData = false;

        $.each(attributionKeys, function (_, key) {
            touch[key] = getQueryParameter(key);
            hasCampaignData = hasCampaignData || touch[key] !== '';
        });

        touch.has_campaign_data = hasCampaignData;
        return touch;
    }

    function captureAttribution() {
        var stored = getStoredAttribution();
        var currentTouch = getCurrentTouch();

        if (!stored) {
            stored = { first: currentTouch, last: currentTouch, expiresAt: Date.now() + attributionLifetime };
        } else if (currentTouch.has_campaign_data) {
            stored.last = currentTouch;
            stored.expiresAt = Date.now() + attributionLifetime;
        }

        try {
            window.localStorage.setItem(attributionStorageKey, JSON.stringify(stored));
        } catch (error) {
            // Attribution must never prevent the form from working.
        }

        return stored;
    }

    function populateAttributionFields($form, attribution) {
        if (!attribution) {
            return;
        }

        $.each(['first', 'last'], function (_, touchType) {
            var touch = attribution[touchType] || {};
            var fields = attributionKeys.concat(['landing_page', 'referrer', 'captured_at']);

            $.each(fields, function (__, fieldName) {
                $('<input>', { type: 'hidden', name: touchType + '_' + fieldName, value: touch[fieldName] || '' }).appendTo($form);
            });
        });
    }

    $(function () {
        var attribution = captureAttribution();

        $('[data-anfragen-flow]').each(function () {
            var $flow = $(this);
            var $form = $flow.find('[data-anfragen-form]');
            var $steps = $form.find('[data-step]');
            var $success = $form.find('[data-success-state]');
            var $indicator = $flow.find('[data-step-indicator]');
            var $progress = $flow.find('[data-step-progress]');
            var $title = $flow.find('[data-current-step-title]');
            var $description = $flow.find('[data-current-step-description]');
            var $header = $flow.find('.anfragen-flow-header');
            var $next = $form.find('[data-step-next]');
            var $submit = $form.find('[data-step-submit]');
            var $back = $form.find('[data-step-back]');
            var $navigation = $form.find('[data-form-navigation]');
            var $error = $form.find('[data-form-error]');
            var ajaxUrl = $flow.data('ajax-url');
            var nonce = $flow.data('nonce');
            var totalSteps = parseInt($flow.data('total-steps'), 10) || $steps.length;
            var currentStep = 0;
            var submitLabel = $submit.html();

            populateAttributionFields($form, attribution);

            function clearError() {
                $error.prop('hidden', true).text('');
            }

            function showError(message) {
                $error.text(message).prop('hidden', false);
            }

            function clearFieldError($field) {
                $field.removeClass('is-invalid');
                $field.find('input, textarea').attr('aria-invalid', 'false');
                $field.find('[data-field-error]').prop('hidden', true);
            }

            function showFieldError($input) {
                var $field = $input.closest('.anfragen-field');
                var message = $input.get(0).validity.typeMismatch
                    ? 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
                    : ($input.attr('type') === 'checkbox' ? 'Bitte bestätigen Sie die Datenschutzerklärung.' : 'Bitte füllen Sie dieses Feld aus.');

                $field.addClass('is-invalid');
                $input.attr('aria-invalid', 'true');
                $field.find('[data-field-error]').first().text(message).prop('hidden', false);
            }

            function syncProjectDetails() {
                var selectedTrades = {};

                $form.find('input[name="trades[]"]:checked').each(function () {
                    selectedTrades[this.value] = true;
                });

                $form.find('[data-trade-option]').each(function () {
                    var $option = $(this);
                    var $input = $option.find('input');
                    var visible = Boolean(selectedTrades[$option.attr('data-trade-option')]);

					$option.prop('hidden', !visible).toggle(visible);
                    $input.prop('disabled', !visible);

                    if (!visible) {
                        $input.prop('checked', false);
                    }
                });
            }

            function validateStep() {
                var $current = $steps.eq(currentStep);
                var type = $current.data('step-type');
                var valid = true;

                clearError();

                if (type === 'contact' || type === 'input') {
                    $current.find('.anfragen-field').each(function () { clearFieldError($(this)); });
                    $current.find('input[required], textarea[required]').each(function () {
                        if (!this.checkValidity()) {
                            valid = false;
                            showFieldError($(this));
                        }
                    });
                    return valid;
                }

                if (type === 'choices-optional') {
                    return true;
                }

                if (!$current.find('input:checked').length) {
                    showError(type === 'cards-single' ? 'Bitte wählen Sie ein Gewerk aus.' : (type === 'cards-multiple' ? 'Bitte wählen Sie mindestens ein Gewerk aus.' : 'Bitte wählen Sie eine Option aus, um fortzufahren.'));
                    return false;
                }

                return true;
            }

            function updateNextState() {
                var $current = $steps.eq(currentStep);
                var type = $current.data('step-type');
                var ready = false;

				if (type === 'choices-optional') {
					ready = true;
				} else if (type === 'input') {
                    ready = true;
                    $current.find('input[required], textarea[required]').each(function () {
                        if (!this.checkValidity()) {
                            ready = false;
                            return false;
                        }
                    });
                } else if (type !== 'contact') {
                    ready = $current.find('input:checked').length > 0;
                }

                $next.toggleClass('is-ready', ready).attr('aria-disabled', ready ? 'false' : 'true');
            }

            function activateStep(index) {
                var $current;
                var isLast;
                var autoAdvance;

                if (index < 0 || index >= $steps.length) {
                    return;
                }

                currentStep = index;
                $steps.each(function (stepIndex) {
                    $(this).toggleClass('is-active', stepIndex === currentStep).toggleClass('is-hidden', stepIndex !== currentStep);
                });

                $current = $steps.eq(currentStep);
                isLast = currentStep === $steps.length - 1;
                autoAdvance = Boolean($current.data('step-auto-advance'));
                clearError();
                $indicator.text('Schritt ' + (currentStep + 1) + ' / ' + totalSteps);
                $progress.css('width', (((currentStep + 1) / totalSteps) * 100) + '%');
                $title.text($current.data('step-heading') || '');
                $description.text($current.data('step-description') || '').prop('hidden', !$current.data('step-description'));
                $back.prop('disabled', currentStep === 0);
                $next.prop('hidden', isLast || autoAdvance);
                $submit.prop('hidden', !isLast);
                updateNextState();
            }

            function scrollToFlowTop() {
                var headerHeight = $('.site-header').outerHeight() || 0;
                var targetTop = Math.max(0, $flow.offset().top - headerHeight - 20);
                window.scrollTo({ top: targetTop, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            }

            function payload() {
                var data = { action: 'dd_submit_anfragen_form', nonce: nonce };

                $.each($form.serializeArray(), function (_, field) {
                    if (field.name.slice(-2) === '[]') {
                        var key = field.name.slice(0, -2);
                        data[key] = data[key] || [];
                        data[key].push(field.value);
                    } else {
                        data[field.name] = field.value;
                    }
                });

                return data;
            }

            function showSuccess() {
                $steps.addClass('is-hidden').removeClass('is-active');
                $success.removeClass('is-hidden');
                $header.prop('hidden', true);
                $navigation.addClass('is-hidden');
            }

            $form.on('input change', 'input, textarea', function () {
                var $field = $(this).closest('.anfragen-field');
				var shouldAutoAdvance = $(this).is(':radio:checked') && Boolean($steps.eq(currentStep).data('step-auto-advance'));

				if ($(this).attr('name') === 'trades[]') {
					syncProjectDetails();
				}

                clearError();
                updateNextState();
                if ($field.hasClass('is-invalid') && this.checkValidity()) {
                    clearFieldError($field);
                }

				if (shouldAutoAdvance && validateStep()) {
					activateStep(currentStep + 1);
					scrollToFlowTop();
				}
            });

            $next.on('click', function () {
                if (validateStep()) {
                    activateStep(currentStep + 1);
                    scrollToFlowTop();
                }
            });

            $back.on('click', function () {
                activateStep(currentStep - 1);
                scrollToFlowTop();
            });

            $form.on('submit', function (event) {
                event.preventDefault();
                if (!validateStep()) {
                    return;
                }

                $submit.prop('disabled', true).text('Wird gesendet …');
                clearError();

                $.post(ajaxUrl, payload())
                    .done(function (response) {
                        if (response && response.success) {
                            showSuccess();
                            return;
                        }
                        showError(response && response.data && response.data.message ? response.data.message : 'Beim Senden ist ein Fehler aufgetreten.');
                    })
                    .fail(function (xhr) {
                        var response = xhr.responseJSON;
                        showError(response && response.data && response.data.message ? response.data.message : 'Die Anfrage konnte gerade nicht gesendet werden. Bitte versuchen Sie es erneut.');
                    })
                    .always(function () {
                        $submit.prop('disabled', false).html(submitLabel);
                    });
            });

			syncProjectDetails();
			activateStep(0);
        });
    });
})(jQuery);
